import React, { useEffect, useState } from "react";
import { getEmailID } from "./core/_request";
import InstagramIcon from "@mui/icons-material/Instagram";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./Footer2.css";

const Footer2 = () => {
  const navigate = useNavigate();
  const [subscribeMessage, setSubscribeMessage] = useState("");
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const authToken = localStorage.getItem("Authorization")?.split("Bearer ")[1];
  const [isRegisterAsProfessional, setIsRegisterAsProfessional] =
    useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  useEffect(() => {
    window.location.host.includes("ask-sam.ai")
      ? setRedirectUrl(
          `https://programs.ask-sam.ai/?token=${authToken}`,
          "_blank"
        )
      : setRedirectUrl(
          `https://programs.unitedwecare.com/?token=${authToken}`,
          "_blank"
        );
  }, []);

  useEffect(() => {
    // Check if the current pathname is '/register-as-professional'
    if (window.location.pathname === "/register-as-professional") {
      setIsRegisterAsProfessional(true);
    }
  }, []);

  

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const navigateToPage = (url) => {
    navigate(`${url}`);
  };

  const onClickSubmit = () => {
    var body = {
      email: email,
    };
    getEmailID(body).then((resp) => {
      // console.log("resp", resp)
      toast(resp?.ResponseMessage);
      if (resp.ResponseCode == 200) {
        setEmail("");
      }
    });
  };

  const onSubscribeClick = () => {
    fetch(
      `https://odoo.unitedwecare.ca/new-uwc/community/newsletter/subscribe/${email}`
    )
      .then((response) => response)
      .then((data) => {
        //console.log("DATA", data)
        // setSubscribeMessage(data)
        //toast("Thank You for Subscribing!");
        setOpen(true);
        setEmail("");
      });
  };
  return (
    <div className={`${isRegisterAsProfessional ? "d-none" : ""}`}>
      <div className={`Footer--Container `}>
        <div className="Footer--Container__Left col-md-3">
          <div>
            <a
              href="https://www.unitedwecare.com/"
              className="text-decoration-none px-0"
            >
              <img
                src="/assets/img/kareify/UWC logo.png"
                alt=""
                width={240}
                height={65}
                style={{ objectFit: "contain", filter: "brightness(5)" }}
              />
            </a>
            <p>
              We are a deep tech <span>Generative AI company</span> with a human
              touch. Our mission is to make mental health and wellness
              affordable, accessible and adaptable for billions.
            </p>
          </div>

          <div>
            <h6 className="py-1">Subscribe to our Newsletter</h6>

            <div className="Newsletter--Input">
              <input
                type="text"
                placeholder="Enter your Email ID..."
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button onClick={onSubscribeClick}>Submit</button>
            </div>
          </div>
        </div>

        <div className="Footer--Container__Middle col-md-6">
          <div className="Middle--Left">
            <div className="">
              <h6>Company</h6>
              <a
                href="https://www.unitedwecare.com/about-us/"
                className="text-decoration-none lh-lg"
                target="_blank"
                rel="noreferrer"
              >
                <p>About Us</p>
              </a>
              <a
                href="https://www.unitedwecare.com/careers/"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <p>Careers</p>
              </a>
              <a
                href="https://www.unitedwecare.com/contact-us/"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <p>Contact Us</p>
              </a>
              {/* <a
                href="https://www.unitedwecare.com/faq"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <p
                  className="font-inter font-w500 lh-base"
                  style={{ fontSize: "14px", color: "#454745" }}
                >
                  FAQ
                </p>
              </a> */}
              <a
                target="_blank"
                className="text-decoration-none"
                href="https://legal.unitedwecare.com/us/terms-and-conditions"
              >
                <p>Terms and Conditions</p>
              </a>
              <a
                target="_blank"
                className="text-decoration-none"
                href="https://legal.unitedwecare.com/us/privacy-policy"
              >
                <p>Privacy Policy</p>
              </a>
              <a
                target="_blank"
                className="text-decoration-none"
                href="https://legal.unitedwecare.com/us/notice-privacy-form"
              >
                <p>Notice of Privacy Practices</p>
              </a>
            </div>

            <div className="mt-5">
              <a
                href="/register-as-professional"
                className="text-decoration-none mt-3"
                rel="noreferrer"
              >
                <h6>Join as Expert</h6>
              </a>
            </div>
          </div>

          <div className="Middle--Right">
            <div>
              <h6>Care</h6>

              <a
                href="/"
                className="text-decoration-none lh-lg"
                // target="_blank"
                rel="noreferrer"
              >
                <p>Professionals</p>
              </a>

              <a href={redirectUrl} className="text-decoration-none" target="">
                <p>Programs</p>
              </a>

              <a
                href="/assessment-list"
                className="text-decoration-none lh-lg"
                rel="noreferrer"
              >
                <p>Assessments</p>
              </a>
            </div>

            <div className="mt-5">
              <h6>Resource Center</h6>

              <a
                href="https://www.unitedwecare.com/blog/"
                className="text-decoration-none lh-lg"
                target="_blank"
                rel="noreferrer"
              >
                <p>Blogs</p>
              </a>

              <a
                href="https://www.unitedwecare.com/whitepapers/"
                className="text-decoration-none lh-lg"
                target="_blank"
                rel="noreferrer"
              >
                <p>Whitepapers</p>
              </a>

              {/* <a
                href="https://www.unitedwecare.com/about-us/"
                className="text-decoration-none lh-lg"
                target="_blank"
                rel="noreferrer"
              >
                <p
                  className="font-inter font-w500 lh-base"
                  style={{ fontSize: "14px", color: "#454745" }}
                >
                  Wellness Library
                </p>
              </a>

              <a
                href="https://www.unitedwecare.com/about-us/"
                className="text-decoration-none lh-lg"
                target="_blank"
                rel="noreferrer"
              >
                <p
                  className="font-inter font-w500 lh-base"
                  style={{ fontSize: "14px", color: "#454745" }}
                >
                  Research Library
                </p>
              </a> */}
            </div>
          </div>
        </div>

        <div className="Footer--Container__Right col-md-3">
          <div className="Right--Top">
            <h6>Download Our App</h6>
            <div className="d-flex align-items-center gap-2 justify-content-start">
              <a
                href="https://play.google.com/store/apps/details?id=com.UnitedFor.Her&hl=en_IN"
                target="_blank"
                rel="noreferrer"
                className=""
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="159"
                  height="47"
                  viewBox="0 0 159 47"
                  fill="none"
                >
                  <path
                    d="M152.199 46.9888H5.85382C2.57568 46.9888 0 44.4044 0 41.1152V5.8736C0 2.58438 2.57568 0 5.85382 0H152.199C155.477 0 158.053 2.58438 158.053 5.8736V41.1152C158.053 44.4044 155.477 46.9888 152.199 46.9888Z"
                    fill="white"
                  />
                  <path
                    d="M152.199 0.939775C154.892 0.939775 157.117 3.17174 157.117 5.8736V41.1152C157.117 43.817 154.892 46.049 152.199 46.049H5.85382C3.16106 46.049 0.936611 43.817 0.936611 41.1152V5.8736C0.936611 3.17174 3.16106 0.939775 5.85382 0.939775H152.199ZM152.199 0H5.85382C2.57568 0 0 2.70185 0 5.8736V41.1152C0 44.4044 2.57568 46.9888 5.85382 46.9888H152.199C155.477 46.9888 158.053 44.4044 158.053 41.1152V5.8736C158.053 2.70185 155.477 0 152.199 0Z"
                    fill="#A6A6A6"
                  />
                  <path
                    d="M55.1598 12.5219C55.1598 13.4864 54.923 14.3304 54.3313 14.9333C53.6212 15.6567 52.7927 16.0185 51.7275 16.0185C50.6624 16.0185 49.8339 15.6567 49.1238 14.9333C48.4136 14.2099 48.0586 13.3659 48.0586 12.2807C48.0586 11.1956 48.4136 10.3516 49.1238 9.62812C49.8339 8.90469 50.6624 8.54297 51.7275 8.54297C52.2009 8.54297 52.6743 8.66354 53.1478 8.90469C53.6212 9.14583 53.9762 9.38698 54.2129 9.74869L53.6212 10.3516C53.1478 9.74869 52.556 9.50755 51.7275 9.50755C51.0174 9.50755 50.3073 9.74869 49.8339 10.3516C49.2421 10.8338 49.0054 11.5573 49.0054 12.4013C49.0054 13.2453 49.2421 13.9687 49.8339 14.451C50.4256 14.9333 51.0174 15.295 51.7275 15.295C52.556 15.295 53.1478 15.0539 53.7395 14.451C54.0946 14.0893 54.3313 13.607 54.3313 13.0041H51.7275V12.0396H55.1598V12.5219ZM60.604 9.50755H57.4085V11.7984H60.3673V12.6424H57.4085V14.9333H60.604V15.8979H56.4616V8.66354H60.604V9.50755ZM64.5096 15.8979H63.5628V9.50755H61.5508V8.66354H66.5216V9.50755H64.5096V15.8979ZM69.9538 15.8979V8.66354H70.9007V15.8979H69.9538ZM74.9247 15.8979H73.9778V9.50755H71.9658V8.66354H76.8183V9.50755H74.8063V15.8979H74.9247ZM86.1682 14.9333C85.458 15.6567 84.6296 16.0185 83.5644 16.0185C82.4992 16.0185 81.6708 15.6567 80.9606 14.9333C80.2505 14.2099 79.8955 13.3659 79.8955 12.2807C79.8955 11.1956 80.2505 10.3516 80.9606 9.62812C81.6708 8.90469 82.4992 8.54297 83.5644 8.54297C84.6296 8.54297 85.458 8.90469 86.1682 9.62812C86.8783 10.3516 87.2333 11.1956 87.2333 12.2807C87.2333 13.3659 86.8783 14.2099 86.1682 14.9333ZM81.6708 14.3304C82.1442 14.8127 82.8543 15.1744 83.5644 15.1744C84.2745 15.1744 84.9846 14.9333 85.458 14.3304C85.9315 13.8482 86.2865 13.1247 86.2865 12.2807C86.2865 11.4367 86.0498 10.7133 85.458 10.231C84.9846 9.74869 84.2745 9.38698 83.5644 9.38698C82.8543 9.38698 82.1442 9.62812 81.6708 10.231C81.1974 10.7133 80.8423 11.4367 80.8423 12.2807C80.8423 13.1247 81.079 13.8482 81.6708 14.3304ZM88.5352 15.8979V8.66354H89.6004L93.0326 14.3304V8.66354H93.9794V15.8979H93.0326L89.3637 9.98984V15.8979H88.5352Z"
                    fill="black"
                    stroke="black"
                    stroke-width="0.1"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M79.7556 25.636C76.9381 25.636 74.7075 27.6834 74.7075 30.527C74.7075 33.2568 76.9381 35.4179 79.7556 35.4179C82.5731 35.4179 84.8036 33.3706 84.8036 30.527C84.8036 27.5696 82.5731 25.636 79.7556 25.636ZM79.7556 33.3706C78.2294 33.3706 76.9381 32.1194 76.9381 30.4132C76.9381 28.7071 78.2294 27.4559 79.7556 27.4559C81.2817 27.4559 82.5731 28.5933 82.5731 30.4132C82.5731 32.1194 81.2817 33.3706 79.7556 33.3706ZM68.8377 25.636C66.0202 25.636 63.7897 27.6834 63.7897 30.527C63.7897 33.2568 66.0202 35.4179 68.8377 35.4179C71.6552 35.4179 73.8858 33.3706 73.8858 30.527C73.8858 27.5696 71.6552 25.636 68.8377 25.636ZM68.8377 33.3706C67.3116 33.3706 66.0202 32.1194 66.0202 30.4132C66.0202 28.7071 67.3116 27.4559 68.8377 27.4559C70.3639 27.4559 71.6552 28.5933 71.6552 30.4132C71.6552 32.1194 70.3639 33.3706 68.8377 33.3706ZM55.8067 27.1147V29.162H60.8548C60.7374 30.2995 60.2678 31.2094 59.6808 31.7781C58.9764 32.4606 57.8025 33.2568 55.8067 33.2568C52.637 33.2568 50.2891 30.8682 50.2891 27.7971C50.2891 24.726 52.7544 22.3374 55.8067 22.3374C57.4503 22.3374 58.7416 23.0199 59.6808 23.8161L61.207 22.3374C59.9156 21.2 58.2721 20.29 55.9241 20.29C51.6979 20.29 48.0586 23.7023 48.0586 27.7971C48.0586 31.8919 51.6979 35.3042 55.9241 35.3042C58.2721 35.3042 59.9156 34.6217 61.3244 33.1431C62.7331 31.7781 63.2027 29.8445 63.2027 28.3658C63.2027 27.9109 63.2027 27.4559 63.0853 27.1147H55.8067ZM109.105 28.7071C108.635 27.5696 107.461 25.636 104.878 25.636C102.296 25.636 100.183 27.5696 100.183 30.527C100.183 33.2568 102.296 35.4179 105.113 35.4179C107.344 35.4179 108.752 34.053 109.222 33.2568L107.578 32.1194C106.991 32.9156 106.287 33.4843 105.113 33.4843C103.939 33.4843 103.235 33.0293 102.648 32.0056L109.339 29.2758L109.105 28.7071ZM102.296 30.2995C102.296 28.4796 103.822 27.4559 104.878 27.4559C105.7 27.4559 106.522 27.9109 106.757 28.4796L102.296 30.2995ZM96.778 34.963H99.0085V20.745H96.778V34.963ZM93.2561 26.6597C92.6692 26.091 91.73 25.5222 90.556 25.5222C88.0907 25.5222 85.7428 27.6834 85.7428 30.4132C85.7428 33.1431 87.9733 35.1905 90.556 35.1905C91.73 35.1905 92.6692 34.6217 93.1387 34.053H93.2561V34.7355C93.2561 36.5554 92.1996 37.5791 90.556 37.5791C89.2647 37.5791 88.3255 36.6691 88.0907 35.8729L86.2124 36.6691C86.7993 37.9203 88.2081 39.5127 90.6734 39.5127C93.2561 39.5127 95.3693 38.034 95.3693 34.508V25.8635H93.2561V26.6597ZM90.6734 33.3706C89.1473 33.3706 87.8559 32.1194 87.8559 30.4132C87.8559 28.7071 89.1473 27.4559 90.6734 27.4559C92.1996 27.4559 93.3735 28.7071 93.3735 30.4132C93.3735 32.1194 92.1996 33.3706 90.6734 33.3706ZM119.318 20.745H114.035V34.963H116.266V29.617H119.318C121.783 29.617 124.131 27.9109 124.131 25.181C124.131 22.4512 121.783 20.745 119.318 20.745ZM119.435 27.5696H116.266V22.6787H119.435C121.079 22.6787 122.018 24.0436 122.018 25.0673C121.901 26.3185 120.962 27.5696 119.435 27.5696ZM132.936 25.5222C131.293 25.5222 129.649 26.2047 129.062 27.6834L131.058 28.4796C131.527 27.6834 132.232 27.4559 133.053 27.4559C134.227 27.4559 135.284 28.1384 135.401 29.2758V29.3895C135.049 29.162 134.11 28.8208 133.171 28.8208C131.058 28.8208 128.945 29.9583 128.945 32.0056C128.945 33.9393 130.706 35.1905 132.584 35.1905C134.11 35.1905 134.814 34.508 135.401 33.8255H135.519V34.963H137.632V29.5033C137.397 27.0009 135.401 25.5222 132.936 25.5222ZM132.701 33.3706C131.997 33.3706 130.94 33.0293 130.94 32.1194C130.94 30.9819 132.232 30.6407 133.288 30.6407C134.227 30.6407 134.697 30.8682 135.284 31.0957C135.049 32.4606 133.875 33.3706 132.701 33.3706ZM145.028 25.8635L142.563 32.0056H142.445L139.862 25.8635H137.515L141.389 34.508L139.158 39.2852H141.389L147.376 25.8635H145.028ZM125.305 34.963H127.536V20.745H125.305V34.963Z"
                    fill="black"
                  />
                  <path
                    d="M12.1753 8.95508C11.8241 9.30631 11.707 9.89169 11.707 10.5941V36.468C11.707 37.1705 11.9412 37.7559 12.2924 38.1071L12.4095 38.2242L26.927 23.7067V23.4726L12.1753 8.95508Z"
                    fill="#B9A3F8"
                    fill-opacity="0.74"
                  />
                  <path
                    d="M31.6048 28.6253L26.8047 23.8252V23.474L31.6048 18.6738L31.7219 18.7909L37.4586 22.069C39.0977 23.0057 39.0977 24.5276 37.4586 25.4643L31.6048 28.6253Z"
                    fill="url(#paint0_linear_591_2905)"
                  />
                  <path
                    d="M31.7314 28.5061L26.8142 23.5889L12.1797 38.2234C12.7651 38.8088 13.5846 38.8088 14.6383 38.3405L31.7314 28.5061Z"
                    fill="url(#paint1_linear_591_2905)"
                  />
                  <path
                    d="M31.7314 18.6735L14.6383 8.95615C13.5846 8.37077 12.7651 8.48784 12.1797 9.07323L26.8142 23.5907L31.7314 18.6735Z"
                    fill="url(#paint2_linear_591_2905)"
                  />
                  <path
                    opacity="0.2"
                    d="M31.6144 28.3896L14.6383 37.9899C13.7017 38.5753 12.8821 38.4582 12.2968 37.9899L12.1797 38.107L12.2968 38.2241C12.8821 38.6924 13.7017 38.8094 14.6383 38.2241L31.6144 28.3896Z"
                    fill="#98A2B3"
                  />
                  <path
                    opacity="0.12"
                    d="M12.1753 37.9893C11.8241 37.638 11.707 37.0527 11.707 36.3502V36.4673C11.707 37.1697 11.9412 37.7551 12.2924 38.1063V37.9893H12.1753ZM37.4638 25.1109L31.61 28.389L31.7271 28.5061L37.4638 25.2279C38.2834 24.7596 38.6346 24.1742 38.6346 23.5889C38.6346 24.1742 38.1663 24.6426 37.4638 25.1109Z"
                    fill="#98A2B3"
                  />
                  <path
                    opacity="0.25"
                    d="M14.6339 9.07213L37.4638 22.0676C38.1663 22.5359 38.6346 23.0042 38.6346 23.5896C38.6346 23.0042 38.2834 22.4188 37.4638 21.9505L14.6339 8.95505C12.9949 8.01844 11.707 8.7209 11.707 10.5941V10.7112C11.707 8.95505 12.9949 8.13551 14.6339 9.07213Z"
                    fill="white"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_591_2905"
                      x1="39.6058"
                      y1="23.5922"
                      x2="11.2768"
                      y2="23.5922"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FFE000" />
                      <stop offset="0.409" stop-color="#FFBD00" />
                      <stop offset="0.775" stop-color="#FFA500" />
                      <stop offset="1" stop-color="#FF9C00" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_591_2905"
                      x1="29.0703"
                      y1="26.2769"
                      x2="2.42605"
                      y2="52.9212"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FF3A44" />
                      <stop offset="1" stop-color="#C31162" />
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_591_2905"
                      x1="8.54681"
                      y1="0.381473"
                      x2="20.4453"
                      y2="12.2799"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#32A071" />
                      <stop offset="0.069" stop-color="#2DA771" />
                      <stop offset="0.476" stop-color="#15CF74" />
                      <stop offset="0.801" stop-color="#06E775" />
                      <stop offset="1" stop-color="#00F076" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                href="https://apps.apple.com/in/app/united-for-her/id1501325167"
                target="_blank"
                rel="noreferrer"
                className=""
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="161"
                  height="48"
                  viewBox="0 0 161 48"
                  fill="none"
                >
                  <path
                    d="M158.993 41.8117C158.993 42.4083 158.875 42.9992 158.646 43.5504C158.418 44.1016 158.083 44.6023 157.661 45.024C157.238 45.4457 156.737 45.7801 156.186 46.008C155.634 46.2359 155.043 46.3529 154.446 46.3522H5.65986C4.45394 46.3535 3.2969 45.8759 2.44318 45.0244C1.58947 44.1729 1.10899 43.0173 1.10742 41.8117V5.60216C1.10899 4.39601 1.58928 3.23979 2.44282 2.38736C3.29637 1.53493 4.4534 1.05598 5.65986 1.05566H154.445C155.042 1.05566 155.633 1.17327 156.185 1.40177C156.737 1.63027 157.238 1.96518 157.66 2.38737C158.082 2.80957 158.417 3.31078 158.646 3.86238C158.874 4.41398 158.992 5.00516 158.991 5.60216L158.993 41.8117Z"
                    fill="white"
                  />
                  <path
                    d="M154.447 47.408H5.66057C4.17502 47.4077 2.75026 46.8182 1.69893 45.7689C0.647595 44.7197 0.055561 43.2963 0.0527344 41.8111L0.0527344 5.60279C0.054932 4.1169 0.646575 2.69254 1.69787 1.64219C2.74917 0.591836 4.17428 0.00125415 5.66057 0L154.446 0C155.932 0.00187994 157.356 0.592663 158.408 1.64288C159.459 2.6931 160.051 4.11709 160.053 5.60279V41.8111C160.056 44.8982 157.536 47.408 154.447 47.408Z"
                    fill="#A6A6A6"
                  />
                  <path
                    d="M158.993 41.8117C158.993 42.4083 158.875 42.9992 158.646 43.5504C158.418 44.1016 158.083 44.6023 157.661 45.024C157.238 45.4457 156.737 45.7801 156.186 46.008C155.634 46.2359 155.043 46.3529 154.446 46.3522H5.65986C4.45394 46.3535 3.2969 45.8759 2.44318 45.0244C1.58947 44.1729 1.10899 43.0173 1.10742 41.8117V5.60216C1.10899 4.39601 1.58928 3.23979 2.44282 2.38736C3.29637 1.53493 4.4534 1.05598 5.65986 1.05566H154.445C155.042 1.05566 155.633 1.17327 156.185 1.40177C156.737 1.63027 157.238 1.96518 157.66 2.38737C158.082 2.80957 158.417 3.31078 158.646 3.86238C158.874 4.41398 158.991 5.00516 158.991 5.60216L158.993 41.8117Z"
                    fill="white"
                  />
                  <path
                    d="M35.7824 23.4551C35.7481 19.6342 38.9119 17.7753 39.0565 17.6887C37.2647 15.077 34.4875 14.7202 33.5116 14.6917C31.179 14.4463 28.9164 16.0871 27.7282 16.0871C26.5163 16.0871 24.6865 14.7154 22.7145 14.7557C20.1768 14.7949 17.8027 16.2637 16.5007 18.5447C13.8136 23.1955 15.8176 30.03 18.3921 33.7894C19.6799 35.6317 21.1848 37.6862 23.1544 37.6139C25.0814 37.5356 25.8012 36.3868 28.1267 36.3868C30.4307 36.3868 31.1067 37.6139 33.1155 37.5676C35.1836 37.5356 36.4856 35.7182 37.7284 33.8605C39.2166 31.7514 39.8143 29.672 39.838 29.5653C39.7906 29.5487 35.8228 28.0336 35.7824 23.4551ZM31.9878 12.2187C33.0242 10.9229 33.7333 9.16005 33.5365 7.37109C32.0364 7.43748 30.1604 8.40843 29.0801 9.67576C28.1243 10.7925 27.2705 12.623 27.491 14.3444C29.1761 14.47 30.9063 13.4943 31.9878 12.2187Z"
                    fill="black"
                  />
                  <path
                    d="M63.6881 37.3494H60.9951L59.5199 32.7152H54.3923L52.9871 37.3494H50.3652L55.4466 21.5724H58.5843L63.6881 37.3494ZM59.0752 30.7709L57.7412 26.6512C57.6 26.2303 57.3344 25.2392 56.9455 23.6791H56.898C56.7415 24.3501 56.4913 25.3412 56.1486 26.6512L54.837 30.7709H59.0752ZM76.73 31.5213C76.73 33.4561 76.2047 34.9855 75.1528 36.1081C74.2113 37.1075 73.0409 37.6067 71.6451 37.6067C70.1379 37.6067 69.0541 37.0696 68.3959 35.9932V41.9623H65.8677V29.7122C65.8677 28.4971 65.8357 27.2511 65.774 25.9731H67.9975L68.1386 27.7763H68.186C69.0292 26.4177 70.3087 25.7384 72.0258 25.7384C73.3682 25.7384 74.4888 26.2683 75.3853 27.3293C76.2806 28.3927 76.73 29.7893 76.73 31.5213ZM74.1544 31.6138C74.1544 30.5065 73.9053 29.5937 73.4049 28.8741C72.8582 28.126 72.1242 27.7514 71.204 27.7514C70.5802 27.7514 70.0134 27.96 69.5071 28.3714C68.9995 28.7863 68.6675 29.3281 68.5121 29.9991C68.4428 30.2501 68.4034 30.5083 68.3947 30.7685V32.6666C68.3947 33.4929 68.6485 34.1912 69.1561 34.7626C69.6636 35.3316 70.3229 35.6173 71.134 35.6173C72.0863 35.6173 72.8274 35.2486 73.3575 34.5172C73.8887 33.7833 74.1544 32.8159 74.1544 31.6138ZM89.8181 31.5213C89.8181 33.4561 89.2928 34.9855 88.241 36.1081C87.2982 37.1075 86.129 37.6067 84.7321 37.6067C83.2249 37.6067 82.141 37.0696 81.4829 35.9932V41.9623H78.9546V29.7122C78.9546 28.4971 78.9226 27.2511 78.861 25.9731H81.0844L81.2255 27.7763H81.273C82.1149 26.4177 83.3944 25.7384 85.1127 25.7384C86.4539 25.7384 87.5745 26.2683 88.4734 27.3293C89.3675 28.3927 89.8181 29.7893 89.8181 31.5213ZM87.2413 31.6138C87.2413 30.5065 86.9911 29.5937 86.4907 28.8741C85.944 28.126 85.2123 27.7514 84.2921 27.7514C83.6684 27.7514 83.1015 27.96 82.5928 28.3714C82.0853 28.7863 81.7544 29.3281 81.5991 29.9991C81.522 30.3121 81.4805 30.567 81.4805 30.7685V32.6666C81.4805 33.4929 81.7354 34.1912 82.2406 34.7626C82.7481 35.3304 83.4075 35.6173 84.221 35.6173C85.1744 35.6173 85.9155 35.2486 86.4444 34.5172C86.9757 33.7833 87.2413 32.8159 87.2413 31.6138ZM104.451 32.9238C104.451 34.267 103.982 35.3589 103.049 36.2018C102.022 37.1218 100.588 37.5829 98.7499 37.5829C97.0518 37.5829 95.6904 37.2557 94.6635 36.6001L95.2481 34.4935C96.3568 35.1502 97.5747 35.4774 98.9005 35.4774C99.8539 35.4774 100.595 35.2617 101.124 34.8337C101.654 34.4045 101.922 33.8308 101.922 33.1147C101.922 32.4733 101.7 31.9363 101.265 31.4988C100.827 31.0626 100.104 30.6559 99.0878 30.2825C96.3248 29.2523 94.9421 27.7454 94.9421 25.7633C94.9421 24.4687 95.4307 23.4088 96.4055 22.5801C97.3802 21.7526 98.6728 21.3389 100.281 21.3389C101.717 21.3389 102.913 21.589 103.863 22.0881L103.229 24.1486C102.335 23.6649 101.326 23.423 100.197 23.423C99.3049 23.423 98.6052 23.6423 98.1048 24.0786C97.6838 24.4687 97.4704 24.9441 97.4704 25.5084C97.4704 26.1308 97.7134 26.6477 98.1973 27.0531C98.6171 27.4265 99.3831 27.8332 100.491 28.2695C101.85 28.8172 102.848 29.455 103.487 30.1876C104.131 30.9203 104.451 31.8343 104.451 32.9238ZM112.832 27.8699H110.045V33.3933C110.045 34.7981 110.536 35.4988 111.52 35.4988C111.972 35.4988 112.347 35.4609 112.643 35.3814L112.713 37.3008C112.215 37.4869 111.559 37.5806 110.747 37.5806C109.749 37.5806 108.968 37.2759 108.405 36.6665C107.844 36.0572 107.562 35.0364 107.562 33.5996V27.8652H105.902V25.9683H107.562V23.8854L110.045 23.1361V25.9683H112.832V27.8699ZM125.38 31.5676C125.38 33.3162 124.88 34.7519 123.881 35.8746C122.837 37.0305 121.447 37.6067 119.714 37.6067C118.042 37.6067 116.713 37.053 115.722 35.9469C114.73 34.8384 114.235 33.4419 114.235 31.7573C114.235 29.9944 114.747 28.5504 115.768 27.4277C116.791 26.3038 118.169 25.7419 119.902 25.7419C121.571 25.7419 122.913 26.2967 123.928 27.404C124.898 28.4781 125.38 29.8652 125.38 31.5676ZM122.76 31.6257C122.76 30.5836 122.534 29.6897 122.082 28.9416C121.552 28.0383 120.793 27.5866 119.81 27.5866C118.798 27.5866 118.021 28.0383 117.492 28.9416C117.039 29.6897 116.814 30.599 116.814 31.6731C116.814 32.7164 117.039 33.6126 117.492 34.3583C118.039 35.2617 118.801 35.7134 119.789 35.7134C120.756 35.7134 121.513 35.2522 122.061 34.3358C122.526 33.5699 122.76 32.6701 122.76 31.6257ZM133.602 28.1959C133.339 28.1485 133.072 28.1251 132.805 28.126C131.915 28.126 131.228 28.4603 130.744 29.1337C130.324 29.7265 130.113 30.4757 130.113 31.3803V37.3494H127.585V29.5557C127.587 28.3615 127.562 27.1674 127.511 25.9743H129.713L129.806 28.1509H129.876C130.144 27.4028 130.564 26.7994 131.14 26.3477C131.667 25.953 132.308 25.7393 132.967 25.7384C133.201 25.7384 133.412 25.755 133.599 25.7846L133.602 28.1959ZM144.909 31.123C144.915 31.5072 144.884 31.8912 144.816 32.2694H137.232C137.26 33.3933 137.628 34.254 138.332 34.8467C138.971 35.3755 139.798 35.6411 140.813 35.6411C141.936 35.6411 142.96 35.4632 143.882 35.104L144.278 36.8574C143.201 37.3269 141.93 37.5604 140.463 37.5604C138.698 37.5604 137.313 37.0412 136.305 36.005C135.3 34.9677 134.796 33.5735 134.796 31.8272C134.796 30.1129 135.264 28.6844 136.202 27.5451C137.184 26.3287 138.511 25.7206 140.181 25.7206C141.821 25.7206 143.062 26.3287 143.905 27.5451C144.573 28.5089 144.909 29.7039 144.909 31.123ZM142.498 30.4674C142.516 29.717 142.35 29.0709 142.007 28.5243C141.569 27.8201 140.896 27.4692 139.993 27.4692C139.167 27.4692 138.493 27.8118 137.981 28.4994C137.56 29.046 137.31 29.7028 137.233 30.465L142.498 30.4674Z"
                    fill="black"
                  />
                  <path
                    d="M53.6636 15.9947C52.9604 15.9947 52.3521 15.9603 51.8457 15.9022V8.27457C52.5539 8.16519 53.2696 8.11129 53.9861 8.11333C56.8855 8.11333 58.2208 9.53952 58.2208 11.8643C58.2208 14.546 56.6436 15.9947 53.6636 15.9947ZM54.0881 9.09139C53.6968 9.09139 53.3636 9.1151 53.0873 9.17201V14.9704C53.2367 14.9941 53.5237 15.0048 53.9268 15.0048C55.8266 15.0048 56.9081 13.9236 56.9081 11.8987C56.9081 10.0932 55.9297 9.09139 54.0881 9.09139ZM62.3819 16.0528C60.7478 16.0528 59.6888 14.8329 59.6888 13.1767C59.6888 11.4506 60.7703 10.22 62.4744 10.22C64.0848 10.22 65.1674 11.3818 65.1674 13.0854C65.1674 14.8329 64.0516 16.0528 62.3819 16.0528ZM62.4293 11.1281C61.5316 11.1281 60.9565 11.9675 60.9565 13.1411C60.9565 14.2923 61.5435 15.1316 62.4175 15.1316C63.2914 15.1316 63.8784 14.2342 63.8784 13.1174C63.8784 11.9793 63.3033 11.1281 62.4293 11.1281ZM74.4858 10.335L72.7366 15.926H71.597L70.8725 13.498C70.6923 12.9041 70.5423 12.3015 70.4231 11.6924H70.3994C70.308 12.3018 70.1349 12.9123 69.9511 13.498L69.1803 15.926H68.0289L66.3829 10.335H67.6601L68.2933 12.993C68.4427 13.626 68.5684 14.2235 68.6728 14.7878H68.6965C68.7878 14.3172 68.9372 13.7292 69.1566 13.0048L69.9511 10.3362H70.9638L71.7239 12.9479C71.9077 13.581 72.0572 14.2022 72.1734 14.789H72.2066C72.2872 14.2141 72.4141 13.6035 72.586 12.9479L73.2655 10.3362L74.4858 10.335ZM80.9249 15.926H79.6821V12.7155C79.6821 11.7268 79.3026 11.2313 78.5544 11.2313C77.818 11.2313 77.3116 11.8643 77.3116 12.6006V15.926H76.0689V11.9331C76.0689 11.4387 76.057 10.9088 76.0226 10.3338H77.1159L77.1741 11.1969H77.2084C77.5429 10.5994 78.2211 10.22 78.9813 10.22C80.1553 10.22 80.926 11.1175 80.926 12.578L80.9249 15.926ZM84.3519 15.926H83.108V7.76953H84.3519V15.926ZM88.883 16.0528C87.2501 16.0528 86.19 14.8329 86.19 13.1767C86.19 11.4506 87.2715 10.22 88.9743 10.22C90.5859 10.22 91.6674 11.3818 91.6674 13.0854C91.6686 14.8329 90.5515 16.0528 88.883 16.0528ZM88.9293 11.1281C88.0316 11.1281 87.4565 11.9675 87.4565 13.1411C87.4565 14.2923 88.0447 15.1316 88.9162 15.1316C89.7914 15.1316 90.3772 14.2342 90.3772 13.1174C90.3784 11.9793 89.8044 11.1281 88.9293 11.1281ZM96.5673 15.926L96.4772 15.2822H96.444C96.0645 15.8003 95.5107 16.0528 94.8087 16.0528C93.8066 16.0528 93.0951 15.351 93.0951 14.4073C93.0951 13.0273 94.2917 12.3137 96.3633 12.3137V12.2105C96.3633 11.4743 95.9732 11.1056 95.2024 11.1056C94.651 11.1056 94.1671 11.2443 93.7414 11.5205L93.4888 10.7037C94.0059 10.3812 94.651 10.22 95.4087 10.22C96.8697 10.22 97.6073 10.9906 97.6073 12.533V14.5922C97.6073 15.1565 97.6322 15.594 97.6879 15.9271L96.5673 15.926ZM96.3965 13.1411C95.0162 13.1411 94.3237 13.4755 94.3237 14.2686C94.3237 14.8554 94.6806 15.1423 95.1763 15.1423C95.8083 15.1423 96.3965 14.6598 96.3965 14.0042V13.1411ZM103.642 15.926L103.584 15.0285H103.55C103.193 15.7066 102.593 16.0528 101.754 16.0528C100.406 16.0528 99.4074 14.8673 99.4074 13.1992C99.4074 11.4506 100.443 10.2188 101.856 10.2188C102.604 10.2188 103.134 10.4713 103.433 10.9788H103.458V7.76953H104.702V14.4191C104.702 14.9597 104.715 15.466 104.748 15.926H103.642ZM103.458 12.6361C103.458 11.8537 102.94 11.1862 102.149 11.1862C101.228 11.1862 100.664 12.003 100.664 13.153C100.664 14.2804 101.249 15.0522 102.124 15.0522C102.906 15.0522 103.458 14.3729 103.458 13.5679V12.6361ZM112.589 16.0528C110.956 16.0528 109.897 14.8329 109.897 13.1767C109.897 11.4506 110.979 10.22 112.682 10.22C114.293 10.22 115.375 11.3818 115.375 13.0854C115.376 14.8329 114.26 16.0528 112.589 16.0528ZM112.635 11.1281C111.739 11.1281 111.164 11.9675 111.164 13.1411C111.164 14.2923 111.751 15.1316 112.624 15.1316C113.499 15.1316 114.085 14.2342 114.085 13.1174C114.087 11.9793 113.512 11.1281 112.635 11.1281ZM122.058 15.926H120.814V12.7155C120.814 11.7268 120.435 11.2313 119.686 11.2313C118.95 11.2313 118.445 11.8643 118.445 12.6006V15.926H117.201V11.9331C117.201 11.4387 117.189 10.9088 117.155 10.3338H118.248L118.306 11.1969H118.34C118.674 10.5994 119.353 10.2188 120.112 10.2188C121.286 10.2188 122.058 11.1163 122.058 12.5768V15.926ZM130.419 11.2668H129.052V13.9817C129.052 14.6728 129.292 15.0178 129.776 15.0178C129.995 15.0178 130.179 14.9941 130.327 14.9597L130.361 15.9034C130.121 15.9959 129.798 16.0421 129.397 16.0421C128.418 16.0421 127.832 15.5015 127.832 14.086V11.2668H127.016V10.335H127.832V9.31072L129.052 8.94202V10.3338H130.419V11.2668ZM136.998 15.926H135.757V12.7393C135.757 11.7387 135.379 11.2325 134.629 11.2325C133.985 11.2325 133.385 11.6699 133.385 12.5555V15.926H132.144V7.76953H133.385V11.1281H133.41C133.801 10.5188 134.368 10.2188 135.092 10.2188C136.275 10.2188 136.998 11.1388 136.998 12.6006V15.926ZM143.739 13.4292H140.009C140.033 14.4879 140.734 15.0854 141.771 15.0854C142.323 15.0854 142.83 14.9929 143.279 14.821L143.472 15.6841C142.943 15.9141 142.321 16.0291 141.596 16.0291C139.847 16.0291 138.812 14.9242 138.812 13.2111C138.812 11.4968 139.872 10.2082 141.456 10.2082C142.885 10.2082 143.782 11.2668 143.782 12.8661C143.79 13.0548 143.775 13.2439 143.739 13.4292ZM142.599 12.5436C142.599 11.6806 142.164 11.0712 141.369 11.0712C140.656 11.0712 140.091 11.6924 140.011 12.5436H142.599Z"
                    fill="black"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="Right--Middle">
            <h6>Follow Us</h6>
            <div className="d-flex gap-3">
              {/* LinkedIn */}
              <a
                href="https://in.linkedin.com/company/unitedwecare"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M29.1645 0.407959H2.23641C1.00253 0.407959 0 1.42451 0 2.67242V29.5515C0 30.7994 1.00253 31.8159 2.23641 31.8159H29.1645C30.3984 31.8159 31.408 30.7994 31.408 29.5515V2.67242C31.408 1.42451 30.3984 0.407959 29.1645 0.407959ZM9.49249 27.3291H4.83739V12.3402H9.49951V27.3291H9.49249ZM7.16494 10.2931C5.67166 10.2931 4.46582 9.0802 4.46582 7.59393C4.46582 6.10766 5.67166 4.89481 7.16494 4.89481C8.65121 4.89481 9.86406 6.10766 9.86406 7.59393C9.86406 9.08721 8.65822 10.2931 7.16494 10.2931ZM26.9421 27.3291H22.287V20.0379C22.287 18.2993 22.252 16.0629 19.8683 16.0629C17.4426 16.0629 17.0711 17.9558 17.0711 19.9117V27.3291H12.416V12.3402H16.8818V14.3873H16.9449C17.5688 13.2095 19.0902 11.9686 21.3546 11.9686C26.0658 11.9686 26.9421 15.0744 26.9421 19.1125V27.3291Z"
                    fill="white"
                  />
                </svg>
              </a>

              {/* Github */}
              <a
                href="https://github.com/United-We-Care"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clip-path="url(#clip0_593_2656)">
                    <path
                      d="M11.2023 24.7859C11.2023 24.9086 11.0612 25.0067 10.8833 25.0067C10.6809 25.0251 10.5398 24.927 10.5398 24.7859C10.5398 24.6632 10.6809 24.5651 10.8588 24.5651C11.0428 24.5467 11.2023 24.6448 11.2023 24.7859ZM9.29452 24.5099C9.25158 24.6325 9.37426 24.7736 9.5583 24.8104C9.71779 24.8718 9.90182 24.8104 9.93863 24.6878C9.97543 24.5651 9.85888 24.424 9.67485 24.3688C9.51535 24.3258 9.33746 24.3872 9.29452 24.5099ZM12.0059 24.4056C11.828 24.4485 11.7053 24.5651 11.7237 24.7062C11.7421 24.8288 11.9016 24.9086 12.0857 24.8657C12.2636 24.8227 12.3862 24.7062 12.3678 24.5835C12.3494 24.4669 12.1838 24.3872 12.0059 24.4056ZM16.0423 0.898682C7.53395 0.898682 1.02539 7.35817 1.02539 15.8665C1.02539 22.6695 5.30718 28.4911 11.4231 30.5399C12.2083 30.681 12.4844 30.1964 12.4844 29.7977C12.4844 29.4174 12.466 27.3194 12.466 26.0312C12.466 26.0312 8.17193 26.9513 7.27018 24.2031C7.27018 24.2031 6.57086 22.418 5.56482 21.958C5.56482 21.958 4.16005 20.9949 5.66297 21.0133C5.66297 21.0133 7.19043 21.136 8.03084 22.5959C9.37426 24.9638 11.6256 24.2829 12.5028 23.878C12.6439 22.8965 13.0426 22.2156 13.4843 21.8107C10.0552 21.4304 6.5954 20.9335 6.5954 15.0323C6.5954 13.3453 7.06161 12.4988 8.04311 11.4191C7.88361 11.0204 7.36219 9.37638 8.2026 7.25389C9.48468 6.85515 12.4353 8.91016 12.4353 8.91016C13.6622 8.56664 14.9811 8.38874 16.2877 8.38874C17.5943 8.38874 18.9132 8.56664 20.1401 8.91016C20.1401 8.91016 23.0907 6.84902 24.3728 7.25389C25.2132 9.38251 24.6918 11.0204 24.5323 11.4191C25.5138 12.5049 26.115 13.3514 26.115 15.0323C26.115 20.9519 22.5018 21.4243 19.0727 21.8107C19.6371 22.2954 20.1155 23.2155 20.1155 24.6571C20.1155 26.7244 20.0971 29.2824 20.0971 29.7854C20.0971 30.1841 20.3793 30.6688 21.1584 30.5277C27.2928 28.4911 31.4519 22.6695 31.4519 15.8665C31.4519 7.35817 24.5507 0.898682 16.0423 0.898682ZM6.988 22.0561C6.90825 22.1175 6.92665 22.2585 7.03094 22.3751C7.12909 22.4733 7.27018 22.5162 7.34992 22.4364C7.42967 22.3751 7.41127 22.234 7.30698 22.1175C7.20883 22.0193 7.06774 21.9764 6.988 22.0561ZM6.32548 21.5592C6.28254 21.639 6.34389 21.7371 6.46657 21.7985C6.56472 21.8598 6.68741 21.8414 6.73035 21.7555C6.77329 21.6758 6.71195 21.5776 6.58926 21.5163C6.46657 21.4795 6.36842 21.4979 6.32548 21.5592ZM8.31302 23.7431C8.21487 23.8228 8.25167 24.0068 8.39277 24.1234C8.53386 24.2645 8.71175 24.2829 8.7915 24.1847C8.87125 24.105 8.83444 23.921 8.71175 23.8044C8.5768 23.6633 8.39277 23.6449 8.31302 23.7431ZM7.6137 22.8413C7.51555 22.9027 7.51555 23.0621 7.6137 23.2032C7.71185 23.3443 7.87748 23.4057 7.95723 23.3443C8.05538 23.2646 8.05538 23.1051 7.95723 22.964C7.87134 22.8229 7.71185 22.7616 7.6137 22.8413Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_593_2656">
                      <rect
                        width="31.408"
                        height="31.408"
                        fill="white"
                        transform="translate(0.53418 0.407959)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>

              {/* YouTube */}
              <a
                href="https://youtube.com/@unitedwecare6397"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <g clip-path="url(#clip0_593_2658)">
                    <path
                      d="M30.04 8.91901C29.6975 7.62943 28.6884 6.6138 27.4072 6.26913C25.0848 5.64282 15.7725 5.64282 15.7725 5.64282C15.7725 5.64282 6.46029 5.64282 4.1379 6.26913C2.85666 6.61385 1.84757 7.62943 1.50508 8.91901C0.882812 11.2564 0.882812 16.1333 0.882812 16.1333C0.882812 16.1333 0.882812 21.0101 1.50508 23.3476C1.84757 24.6372 2.85666 25.6105 4.1379 25.9552C6.46029 26.5815 15.7725 26.5815 15.7725 26.5815C15.7725 26.5815 25.0848 26.5815 27.4072 25.9552C28.6884 25.6105 29.6975 24.6372 30.04 23.3476C30.6623 21.0101 30.6622 16.1333 30.6622 16.1333C30.6622 16.1333 30.6623 11.2564 30.04 8.91901ZM12.7269 20.5611V11.7055L20.5101 16.1334L12.7269 20.5611Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_593_2658">
                      <rect
                        width="31.408"
                        height="31.408"
                        fill="white"
                        transform="translate(0.0683594 0.407959)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>

              {/* Facebook */}
              <a
                href="https://www.facebook.com/unitedwecareglobal"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="32"
                  viewBox="0 0 33 32"
                  fill="none"
                >
                  <path
                    d="M28.6454 0.407959H3.96768C3.07519 0.407959 2.21925 0.762499 1.58817 1.39359C0.957079 2.02467 0.602539 2.88061 0.602539 3.7731L0.602539 28.4508C0.602539 29.3433 0.957079 30.1992 1.58817 30.8303C2.21925 31.4614 3.07519 31.8159 3.96768 31.8159H13.5899V21.1379H9.17313V16.1119H13.5899V12.2813C13.5899 7.92414 16.1838 5.51736 20.1568 5.51736C22.0595 5.51736 24.0491 5.85668 24.0491 5.85668V10.1332H21.8569C19.6969 10.1332 19.0232 11.4737 19.0232 12.8485V16.1119H23.8451L23.074 21.1379H19.0232V31.8159H28.6454C29.5378 31.8159 30.3938 31.4614 31.0249 30.8303C31.656 30.1992 32.0105 29.3433 32.0105 28.4508V3.7731C32.0105 2.88061 31.656 2.02467 31.0249 1.39359C30.3938 0.762499 29.5378 0.407959 28.6454 0.407959Z"
                    fill="white"
                  />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://instagram.com/unitedwecare_global"
                className="text-decoration-none"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M15.8447 8.05933C11.3884 8.05933 7.79388 11.6546 7.79388 16.1119C7.79388 20.5693 11.3884 24.1645 15.8447 24.1645C20.301 24.1645 23.8955 20.5693 23.8955 16.1119C23.8955 11.6546 20.301 8.05933 15.8447 8.05933ZM15.8447 21.3472C12.9649 21.3472 10.6106 18.9994 10.6106 16.1119C10.6106 13.2245 12.9579 10.8767 15.8447 10.8767C18.7315 10.8767 21.0788 13.2245 21.0788 16.1119C21.0788 18.9994 18.7245 21.3472 15.8447 21.3472ZM26.1026 7.72994C26.1026 8.77419 25.2618 9.60818 24.2248 9.60818C23.1808 9.60818 22.347 8.76718 22.347 7.72994C22.347 6.6927 23.1878 5.8517 24.2248 5.8517C25.2618 5.8517 26.1026 6.6927 26.1026 7.72994ZM31.4348 9.63622C31.3157 7.12021 30.7411 4.89156 28.8983 3.05537C27.0626 1.21918 24.8344 0.644491 22.319 0.518341C19.7265 0.371165 11.9559 0.371165 9.3634 0.518341C6.85497 0.637483 4.62681 1.21217 2.78402 3.04836C0.941237 4.88455 0.373686 7.11321 0.247564 9.62921C0.100421 12.2223 0.100421 19.9946 0.247564 22.5877C0.36668 25.1037 0.941237 27.3323 2.78402 29.1685C4.62681 31.0047 6.84797 31.5794 9.3634 31.7055C11.9559 31.8527 19.7265 31.8527 22.319 31.7055C24.8344 31.5864 27.0626 31.0117 28.8983 29.1685C30.7341 27.3323 31.3087 25.1037 31.4348 22.5877C31.582 19.9946 31.582 12.2293 31.4348 9.63622ZM28.0856 25.37C27.539 26.7436 26.481 27.8019 25.1007 28.3555C23.0337 29.1755 18.1289 28.9863 15.8447 28.9863C13.5605 28.9863 8.64871 29.1685 6.58871 28.3555C5.21538 27.8089 4.15736 26.7506 3.60382 25.37C2.78402 23.3025 2.97321 18.3967 2.97321 16.1119C2.97321 13.8272 2.79103 8.91435 3.60382 6.8539C4.15035 5.48026 5.20837 4.422 6.58871 3.86834C8.65572 3.04836 13.5605 3.23758 15.8447 3.23758C18.1289 3.23758 23.0407 3.05537 25.1007 3.86834C26.474 4.41499 27.532 5.47325 28.0856 6.8539C28.9054 8.92136 28.7162 13.8272 28.7162 16.1119C28.7162 18.3967 28.9054 23.3095 28.0856 25.37Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="Right--Bottom">
            <h6>Compliance</h6>
            <div className="d-flex align-items-center gap-3 justify-content-md-start justify-content-center">
              <img
                src="/assets/img/HPPA.webp"
                alt=""
                style={{ borderRadius: "8px", height: "56px" }}
              />
              <img
                src="/assets/img/AES.png"
                alt=""
                style={{ borderRadius: "8px", height: "56px" }}
              />
              <img
                src="/assets/img/ISO.webp"
                alt=""
                style={{ borderRadius: "8px", height: "56px" }}
              />
              {/* <img
                src="/assets/img/iso.webp.png"
                alt=""
                style={{ borderRadius: "8px", height: "56px" }}
              />
              <img
                src="/assets/img/hippa.webp.png"
                alt=""
                style={{ borderRadius: "8px", height: "56px" }}
              /> */}
              {/* <img
                src="/assets/img/image 17763.png"
                alt=""
                style={{ borderRadius: "8px", height: "66px" }}
              /> */}
              {/* <img
                src="/assets/img/image 17762.png"
                alt=""
                style={{ borderRadius: "8px" }}
              /> */}
              {/* <img src='/assets/img/eu.webp.png' alt='' /> */}
              {/* <img
                src="/assets/img/AES.png"
                alt=""
                style={{ borderRadius: "8px", height: "56px" }}
              /> */}
            </div>
          </div>
        </div>
      </div>
      <div className="Footer--Copy">
        © 2024 United We Care. All rights reserved.
      </div>

      <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
        message="Thank You for Subscribing!"
      />
    </div>
  );
};

export default Footer2;
